export const costCenterConfig = {
    headings: [
        {
            headingLabel: "Inactive",
            icon: "",
            width: "13%",
            inputType: "checkbox",
        },
        {
            headingLabel: "Name",
            icon: "",
            width: "40%",
            inputType: "text",
        },
        {
            headingLabel: "Default",
            icon: "",
            width: "15%",
            inputType: "checkbox",
        }
    ],
    dataNodes: [
        "is_active",
        "lookup_value",
        "lookup_code"
    ],
    inlineEdits: [
        {
            dataNode: "is_active",
            width: "12%"
        },
        {
            dataNode: "lookup_value",
            width: "40%",
        },
        {
            dataNode: "lookup_code",
            width: "15%",
        },

    ],
    primaryKey: "lookup_data_id",
    actions: ["pen", "times"],
    nodeFields: [
        {
            column: "is_active",
            icon: "check",
        },
        {
            column: "lookup_code",
            icon: "check",
        },
    ],
    buttonFields: [
        {
            column: "",
            icon: "pen",
        },
    ],
    showActionsItemBottom: [
        {
            dataNode: "is_active",
            width: "13",
        },
        {
            dataNode: "lookup_value",
            width: "40%",
        },
        {
            dataNode: "lookup_code",
            width: "15%",
        },
    ],
    isUnitAdmin: true,
    isClearFields: true
};